import { CSSProperties, memo, ReactNode, useMemo } from 'react'
import { UserLayoutLink, UserLayoutSC, UserLayoutSCProps } from './styled'
import LayoutMenu from '../../components/ui/LayoutMenu'
import { Row } from '../../components/ui/Grid'
import Dropdown from '../../components/ui/Dropdown'
import { authEventEmitter } from '../../pages'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { ReactComponent as DashboardSVG } from './assets/dashboard.svg'
import { ReactComponent as ProductsSVG } from './assets/products.svg'
import Avatar from '../../components/ui/Avatar'
import NotificationBell from '../../components/NotificationBell'
import { margin } from '../../utils/styling/indents'
import { useUserQuery } from '../../components/NotificationBell/hooks'
import config from '../../lib/config'

export interface ClientLayoutProps extends UserLayoutSCProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

function ClientLayout({ className, style, children }: ClientLayoutProps) {
  const history = useHistory()
  const { data } = useUserQuery()
  const match = useRouteMatch({ path: '/product/:id' })
  const actions = useMemo(
    () => [
      {
        label: 'General Info',
        onClick: () => history.push('/settings/general'),
      },
      <hr />,
      {
        label: config.legalPage.statusPage.label,
        onClick: () => window.open(config.legalPage.statusPage.link, '_blank'),
      },
      {
        label: config.legalPage.Wiki.label,
        onClick: () => window.open(config.legalPage.Wiki.link, '_blank'),
      },
      {
        label: config.legalPage.technicalSupport.label,
        onClick: () => window.open(config.legalPage.technicalSupport.link, '_blank'),
      },
      {
        label: config.legalPage.expertHours.label,
        onClick: () => window.open(config.legalPage.expertHours.link, '_blank'),
      },
      {
        label: config.legalPage.termsOfUse.label,
        onClick: () => window.open(config.legalPage.termsOfUse.link, '_blank'),
      },
      {
        label: config.legalPage.privacyPolicy.label,
        onClick: () => window.open(config.legalPage.privacyPolicy.link, '_blank'),
      },
      <hr />,
      {
        label: 'Logout',
        onClick: () => authEventEmitter.emit('logout'),
      },
    ],
    []
  )
  return (
    <UserLayoutSC className={className} style={style}>
      <LayoutMenu
        logoHref='/dashboard'
        menu={
          <Row>
            <UserLayoutLink activeClassName='active' to='/dashboard'>
              <DashboardSVG /> Dashboard
            </UserLayoutLink>
            <UserLayoutLink activeClassName='active' to='/products'>
              <DashboardSVG /> Client Products
            </UserLayoutLink>
          </Row>
        }
        actions={
          <Row>
            <NotificationBell style={margin(4, 18)} />
            <Dropdown options={actions}>
              <Avatar
                src={data?.user.image}
                className='avatar'
                size={44}
                firstName={data?.user.first_name}
              />
            </Dropdown>
          </Row>
        }
      />
      <div className='layout-content-wrapper'>
        <div className='layout-content'>{children}</div>
      </div>
    </UserLayoutSC>
  )
}

export default memo(ClientLayout)
